
import { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { OrderApi } from '../../app/api/order.api';
import { Modal, Row, Col, Card, Placeholder } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';



export function HeaderSection ({ active }) 
{
  return (  

    <div className="border bg-white text-secondary rounded-3 my-4">
      <div className="d-flex justify-content-between flex-column flex-md-row align-items-center border-bottom px-4 py-3 fs-5 gap-3">
        <span> <i className="bi bi-receipt me-2"></i> Gestion des commandes  </span>
        <div>
           <a href="/statistiques-commandes" className='btn btn-sm btn-outline-dark px-3'> Voir statistiques <i className="bi bi-chevron-right ms-1"></i> </a>
        </div>
      </div>  
      <div className="d-flex flex-column">
        <nav className="navbar navbar-expand-sm">
          <div className="container-fluid">
            <button className="navbar-toggler small" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav2" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon small"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav2">
              <ul className="navbar-nav my-2 px-3 gap-3">
                <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===1) ? 'btn-green' : 'btn-outline-green'}`} href="/commandes-en-cours"> En cours </a>
                </li>
                <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===2) ? 'btn-green' : 'btn-outline-green'}`} href="/commandes-livrees"> Livrées </a>
                </li>
                 <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===3)  ? 'btn-green' : 'btn-outline-green'}`} href="/commandes-annulees"> Annulées </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
       </div> 
     </div>
  );
        
}



export function ConfirmedModal({ show, onHide, refetch, order })
{

  const orders = OrderApi();

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); 


  const handleConfirm = async ()=>{

    setStatus(0);
    setIsLoading(true);

    try {
        const {data} = await orders.update( order?.id, { status : "delivered" } );
        if( data.success ){
            setStatus(1);
            setMessage(data.message);
            refetch();
        }
        else{
            setStatus(-1);
            setMessage('Erreur ! veuillez réessayer');
        }
    } catch (err) { 
        
        setStatus(-1);
        setMessage(err?.response?.data.message);
    } finally{
        setIsLoading(false);
    }
  }

  return(

      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green">
            <i className="bi bi-check-circle-fill text-green me-2"></i>
            Confirmation de livraison
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <div className="text-center">
            <i className="bi bi-truck text-green" style={{ fontSize: '3rem' }}></i>
            <p className="mt-3 text-secondary">
              Êtes-vous sûr que cette commande a été livrée avec succès ?
            </p>
            <p className="lead text-muted">
              <strong>Commande :</strong> { order?.ref }
            </p>
            {
              isLoading && (
                <div className="d-flex justify-content-center mb-2"> 
                  <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="alert alert-success mb-2 small w-100"> { message } </div>
              )
            }
            {
              status === -1 && (
                <div className="alert alert-danger mb-2 small w-100"> { message } </div>
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top gap-2">
          <button className="btn btn-sm btn-outline-danger" onClick={onHide}>  Annuler </button>
          <button className="btn btn-sm btn-green" onClick={handleConfirm}>
            <i className="bi bi-check-circle me-2"></i>
            Confirmer
          </button>
        </Modal.Footer>
      </Modal>
    )
}



export function ProductModal({ show, onHide, product })
{
    const [showVideo, setShowVideo] = useState(false);
    const [mainImage, setMainImage] = useState(null);
   
     useEffect(() => {
        if (!product) return;
    
        if (Array.isArray(product.images) && product.images.length > 0) {
          setMainImage(product.images[0].url);
        } else {
          setMainImage(null);
        }
      }, [product]);
    
    
      const handleThumbnailClick = (imageUrl) => {
        setMainImage(imageUrl);
      };

    return(

      <Modal show={show} size="xl" onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom"></Modal.Header>
        <Modal.Body>

            <div className="row">

              {/* Partie Gauche : Images */}
              <div className="col-md-6 p-4">
                <div className="main-image-container mb-3 bg-light d-flex align-items-center justify-content-center">
                   <img src={ mainImage && mainImage } alt="Blue High Hill" className="img-fluid" />
                </div>
                <div className="row g-2 thumb-row">
                {
                  product?.images.map((item, index) => (
                    <div className="col-3" key={index}>
                      <div 
                        className={`thumb ${ mainImage === item.url ? 'active' : '' }`}
                        onClick={() => handleThumbnailClick( item.url )}
                        style={{ cursor: 'pointer', border: mainImage === item.url ? '3px solid black' : 'none' }}
                      >
                        <img src={ item.url } alt={`img-${index + 1}`} className="img-fluid" style={{ maxHeight: '50px' }} />
                      </div>
                    </div>
                  ))
                }
                </div>
              </div>

              {/* Partie Droite : Détails */}
              <div className="col-md-6 p-4 border-start">
                <div className="d-flex align-items-center gap-3 mb-2">
                  <span className="small text-green"> <i className="bi bi-check-circle me-1"></i> Ajouté par : </span>
                  <span className="small text-green">{ product?.user.email }</span>
                </div>
                <h3 className="product-title"> { product?.name } </h3>
                <div className="title-underline mb-3"></div>
                
                <div className="mb-3 text-muted" style={{ maxHeight: '250px', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                  {/* <p className="text-muted"> */}
                     { product?.description }
                  {/* </p> */}
                </div>
                
                <h3 className="product-price mb-3"> { product?.price + " " + product?.currency } </h3>
                {
                  ( product?.video !== "" ) && (
                      <button className="btn btn-outline-green mb-4 px-3" onClick={ ()=> setShowVideo(true) }>
                        <i className="bi bi-play-circle-fill me-2"></i> Lire vidéo
                      </button>  
                  )
                }
                {
                  ( product?.admin !== null ) && (
                     <div className="d-flex align-items-center gap-3 mb-2">
                       <span className="small text-danger"> <i className="bi bi-x-circle me-1"></i> Modifié par : </span>
                       <span className="small text-danger">{ product?.admin }</span>
                     </div>
                  )
                }

                {/* Social */}
                <div className="social-share d-flex gap-2 pt-3 border-top">
                  <div className="social-circle"><i className="bi bi-facebook"></i></div>
                  <div className="social-circle"><i className="bi bi-twitter"></i></div>
                  <div className="social-circle"><i className="bi bi-linkedin"></i></div>
                  <div className="social-circle"><i className="bi bi-google"></i></div>
                  <div className="social-circle"><i className="bi bi-envelope"></i></div>
                </div>
              </div>
            </div>

            {/* Modal de Demande de Maintenance */}
            {
              product?.video && ( <VideoModal show={showVideo} onHide={() => setShowVideo(false)} video={ product?.video } /> )
            }  

        </Modal.Body>
      </Modal>
    )
}




export function VideoModal({show, onHide, video})
{
  return (
    
    <Modal show={show} size="xl" onHide={onHide} centered backdrop="static">
      
      <Modal.Header closeButton className="border-bottom"></Modal.Header>
      <Modal.Body>
           
          <div className="ratio ratio-16x9">
            <video controls poster="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1280&q=80">
              {/* <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" /> */}
              <source src={ video } type="video/mp4" />
            </video>
          </div>
        
      </Modal.Body>
    </Modal>
  );
};




export function formatDateTime(dateString) 
{
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} à ${hours}:${minutes}`;
}





export function StatContainer()
{
    const order = OrderApi(); 

    const fetchData = async () => { 
      const {data} = await order.getCountByStatus();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["orderStats"], queryFn: fetchData });


    if (isLoading){
      return (
        <Row className="g-4">
        {
          Array.from({ length: 3 }).map((_, index) => (
            <Col key={index} lg={4} md={4} sm={6} xs={12}>
              <Placeholder as="div" animation="glow" className="w-100 bg-secondary bg-opacity-25 rounded" style={{ height: '140px' }} />
            </Col>
          ))
        }
        </Row>
      )
    };
    if (error){
      return(
        <div className="text-center p-4 border alert alert-danger w-100">
          Une erreur est survenue. Vueiller vérifier votre connexion 
        </div>
      )
    }

    return(

      <Row className="mb-5 g-4">
        { 
          data.map((item, index) => (
            <Col key={index} lg={4} md={4} sm={6} xs={12}>
              <Card className="stat-card h-100 rounded-0 border">
                <Card.Body className="text-center">
                  <div className="stat-value text-secondary fs-2 mb-2" > {item.count} </div>
                  <div className="text-secondary">{item.status}</div>
                </Card.Body>
              </Card>
            </Col>
        ))}
      </Row>

    )
}





export function Chart1()
{
    const order = OrderApi(); 

    const fetchData = async () => { 
      const {data} = await order.getStatOfYear();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["chart1"], queryFn: fetchData });
    
    return (
      <Row className="mb-5">
        <Col xs={12} className='px-0'>
          <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (

                <Card.Body>
                   <span className="text-muted mb-4"> Commandes par Mois - Année 2025 </span>
                   <ResponsiveContainer width="100%" height={460}>
                     <BarChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}  >
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="month" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                      />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} iconType="square" />
                      <Bar dataKey="livrées" fill="#307072" radius={[8, 8, 0, 0]} name="Livrées" />
                      <Bar dataKey="annulées" fill="#dcad35" radius={[8, 8, 0, 0]} name="Annulées" />
                    </BarChart>
                  </ResponsiveContainer>
                </Card.Body>
              )
            }
            {
              (error) && (
                <Card.Body>
                  <div className="text-center p-4 border alert alert-danger w-100">
                    Une erreur est survenue. Vueiller vérifier votre connexion 
                  </div>
                </Card.Body>
              )
            }
          </Card>
        </Col>
      </Row>
    )
}



export function Chart2()
{
    const order = OrderApi(); 

    const fetchData = async () => { 
      const {data} = await order.getStatOfYears();
      return data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["chart2"], queryFn: fetchData });

    return (
      <Row className="mb-5">
        <Col xs={12} className='px-0'>
          <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (

                <Card.Body>
                   <span className="text-muted mb-4">  Commandes par Année - Les 10 Dernières Années </span>
                    <ResponsiveContainer width="100%" height={460}>
                      <BarChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }} >
                        <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                        <XAxis dataKey="year" tick={{ fill: '#6c757d', fontSize: 12 }} />
                        <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                        <Tooltip
                          contentStyle={{
                            backgroundColor: '#fff',
                            border: '1px solid #dee2e6',
                            borderRadius: '4px',
                         }}
                        />
                        <Legend wrapperStyle={{ paddingTop: '20px' }}iconType="square"/>
                        <Bar dataKey="livrées" fill="#363636" radius={[8, 8, 0, 0]} name="Livrées" />
                        <Bar dataKey="annulées" fill="#edd28c" radius={[8, 8, 0, 0]} name="Annulées"/>
                      </BarChart>
                    </ResponsiveContainer>
                </Card.Body>
              )
            }
            {
              (error) && (
                <Card.Body>
                  <div className="text-center p-4 border alert alert-danger w-100">
                    Une erreur est survenue. Vueiller vérifier votre connexion 
                  </div>
                </Card.Body>
              )
            }
          </Card>
        </Col>
      </Row>
    )
}


